export default {
  title: {
    id: 'press.title',
    defaultMessage: 'Contact',
  },
  description: {
    id: 'press.description',
    defaultMessage: 'For general enquiries, please click the button below',
  },
  button: {
    id: 'press.button',
    defaultMessage: 'Contact Us',
  },
};
